export default __webpack_public_path__ + "static/media/topSort.5c5307c1.svg";